import { KeyDict, Optional } from '@/types'
import { Cast } from '@/modules/casts/classes'
import { computed, ComputedRef } from '@vue/composition-api'
import { pickBy } from 'lodash'


const useCasterNames = (cast: ComputedRef<Optional<Cast>>) => {
  const casterFeedNames = computed(() => {
    if (cast.value === undefined) return {}
    if (cast.value.invited_casters === null) return {}
    const names: KeyDict<string[]> = {}
    Object.keys(cast.value.invited_casters).forEach((casterId) => {
      names[casterId] = Object.keys(pickBy(cast.value?.feedname ?? {}, (value) => value === casterId))
    })
    return names
  })

  return {
    casterFeedNames
  }
}

export default useCasterNames
